import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ImpactTracking.css'; // Reuse existing styles
import util from '../../styles/utilities.module.css';

const ImpactStoryActions = ({ className = '' }) => {
  const navigate = useNavigate();

  return (
    <div className={`impact-tracking ${className}`}>
      <div className="metrics-detail">
        {/* Navigation to Impact Story Actions */}
        <div className="impact-story-actions">
          <div className="impact-story-action">
            <button 
              className={`${util.btn} ${util['btn--accentGradient']} ${util.elevateHover} ${util['m-2']}`}
              onClick={() => navigate('/credentialing/impact-story')}
            >
              📝 Submit Impact Story
            </button>
            <p className="impact-story-help">
              Share your story with us
            </p>
          </div>
          <div className="impact-story-action">
            <button 
              className={`${util.btn} ${util['btn--slateGradient']} ${util.elevateHover} ${util['m-2']}`}
              onClick={() => navigate('/credentialing/impact-stories')}
            >
              📋 View My Impact Stories
            </button>
            <p className="impact-story-help">
              Review all the impact stories you've submitted
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactStoryActions;